import { put, takeLatest } from "redux-saga/effects";
import { xetThucTapApi } from "../../../api/xet-thuc-tap/xetThucTapApi";
import { IXetThucTapThamSoXetRequest } from "../../../model/request/xet-thuc-tap/IXetThucTapThamSoXetRequest";
import { eXetThucTapActionIds, IXetThucTapActionTypes } from "../../action-types/xet-thuc-tap/IXetThucTapActions";
import { rootActions } from "../../actions/rootActions";
import { IXetThucTapRequest } from "../../../model/request/xet-thuc-tap/IXetThucTapRequest";

export function* xetThucTapSaga(): any {
    yield takeLatest(eXetThucTapActionIds.XET_START, xetWorker);
    yield takeLatest(eXetThucTapActionIds.XET_THEO_MON_NGHIEP_VU_START, xetTheoMonNghiepVuWorker);
}

function* xetWorker(action: IXetThucTapActionTypes) : any {
    const request = action.payload as IXetThucTapThamSoXetRequest;
    const response = yield xetThucTapApi.Xet(request);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.xetThucTap.XET_SUCCESS(response.data));
    } else {
        yield put(rootActions.xetThucTap.xetThucTap.XET_ERROR(response.message ?? "Lỗi khi xét thực tập"));
    }
}

function* xetTheoMonNghiepVuWorker(action: IXetThucTapActionTypes) : any {
    const request = action.payload as IXetThucTapRequest;
    const response = yield xetThucTapApi.XetTheoMonNghiepVu(request);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.xetThucTap.XET_THEO_MON_NGHIEP_VU_SUCCESS(response.data));
    } else {
        yield put(rootActions.xetThucTap.xetThucTap.XET_THEO_MON_NGHIEP_VU_ERROR(response.message ?? "Lỗi khi xét thực tập"));
    }
}